import React, { useEffect, useState } from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Card, CardContent, CircularProgress, DialogContent, Divider, Slide, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import './pop-over.scss';
import { CONTACT_SUPPORT, PHONE_HELP_DESC, CLOSE_TEXT, CALL_NUM_TEXT, CALL_NUM } from '../../constants/contactSupportConstants';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction='up' ref={ref} {...props} />;
});

function ContactSupport(props) {

    let { onClose, open } = props;
    const [loading, setLoading] = useState(true);

    const handleClose = () => {
        onClose(null);
    };

    useEffect(() => {
        if (open) {
            const timer = setTimeout(() => {
                setLoading(false);
            }, 1000);
            return () => clearTimeout(timer);
        } else {
            setLoading(true);
        }
    }, [open]);

    return (
        <>
            {
                <Dialog 
					data-testid='contactSupport-pop-over'
					className='dialog-help-cont'
                    TransitionComponent={Transition}
                    keepMounted
                    aria-labelledby='alert-dialog-slide-title'
                    aria-describedby='alert-dialog-slide-description'

                    sx={{
                        '& .MuiDialog-paper': {
                            minWidth: '480px',
                            maxWidth: '480px',
                            maxHeight: '260px',
                            position: 'absolute',
                            borderRadius: '20px',
                            top: '0',
                            left: '0',
                            transform: 'translate(100%, 100%)',
                            height: '260px',
                            backgroundColor: '#ffffff',
                            overflow: 'hidden'
                        },
                        margin: '0 auto'
                    }} onClose={handleClose} open={open}>
					<DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', backgroundColor: 'white', padding: '15px' }}>{CONTACT_SUPPORT}
						<CloseIcon sx={{ width: '20px', height: '20px', cursor:'pointer' }} data-testid='contact-closebuttonontop' onClick={() => handleClose()} />
					</DialogTitle>

                    {loading && open ? (<>
                        <div className='dialog-help-cont--loading'><CircularProgress /></div>
                    </>) : <>
                        <Divider />
                        <DialogContent className='dialog-help-cont--panelcontent'>
                            <Card sx={{ paddingBottom: 0, marginBottom: '8px' }}>
                                <CardContent sx={{ textAlign: 'left' }} style={{ padding: 0 }}>
                                    <Typography variant='h6' component='div'
                                        sx={{
                                            padding: '16px', fontFamily: 'Basis Grotesque Pro',
                                            borderBottom: '1px solid rgb(241, 241, 241)',
                                            borderBottom: 'none', flexDirection: 'column',
                                            display: 'flex', justifyContent: 'space-between',
                                            fontSize: '16px', fontWeight: 'bold', lineHeight: '22px'
                                        }}><p className='dialog-help-cont--call-description'>{PHONE_HELP_DESC}</p>
                                        <span className='dialog-help-cont--call-text' data-testid='contact-callhelppopup' onClick={()=>window.open(`tel:${CALL_NUM}`)}><LocalPhoneOutlinedIcon /> {CALL_NUM_TEXT}</span>
                                    </Typography>


                                </CardContent>
                            </Card>

                            <button className='dialog-help-cont--primary-button' aria-label='Close Help Pop-up'
                                variant='outlined' onClick={() => handleClose()} type='button' data-testid='contact-closehelppopup'>{CLOSE_TEXT}</button>
                        </DialogContent>
                    </>}

                </Dialog >
            }
        </>

    );
}

export default ContactSupport;
